import Vue from 'vue'
import VueSmoothScroll from 'vue2-smooth-scroll' 

import App from './App.vue'
import router from './router'
import store from './store'

import '@/assets/scss/index.scss'
import Buefy from 'buefy'
import { library } from '@fortawesome/fontawesome-svg-core'
// internal icons
import { faCheckCircle, faLock, faUserCircle, faDotCircle, faHandHoldingUsd, faExclamationTriangle, faExclamationCircle, faPlus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import Services from "@/services"

library.add(faCheckCircle, faLock, faUserCircle, faDotCircle, faHandHoldingUsd, faExclamationTriangle, faExclamationCircle, faPlus)
Vue.component('vue-fontawesome', FontAwesomeIcon)

Vue.use(Buefy, {
    defaultIconComponent: 'vue-fontawesome',
    defaultIconPack: 'fas',
})

Vue.use(Services)
Vue.use(VueSmoothScroll)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
